import { theme } from "@covertree/theme";
import {
  Box,
  Card,
  CardHeader,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";

interface Props {
  title?: string;
  subtitle?: string;
  icon: string;
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export const SelectProductStepButton = ({
  children,
  title,
  subtitle,
  icon,
  onClick,
  disabled = false,
}: Props) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <Card
      sx={() => ({
        display: "flex",
        cursor: "pointer",
        borderWidth: 1,
        "&:hover": {
          boxShadow: 2,
          borderColor: theme.palette.primary.main,
        },
        ...(disabled
          ? {
              "&:hover": {
                boxShadow: "none !important",
              },
              opacity: 0.6,
              "&, *": {
                cursor: "not-allowed !important",
              },
              backgroundColor: theme.palette.grey[100],
            }
          : {}),
        borderRadius: theme.spacing(3),
        padding: theme.spacing(0, 3),
      })}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      role="option">
      <Box display="flex" alignItems={"center"} width="100%">
        <Box mr={4} pt={2} pb={2} display="flex" alignItems="center">
          <img
            src={icon}
            alt={title ?? "Product option"}
            width={80}
            height={80}
            style={{ objectFit: "contain" }}
          />
        </Box>

        <Box flexGrow={1}>
          <Box display="flex" alignItems="center">
            <CardHeader
              title={title}
              titleTypographyProps={{
                variant: "body1",
              }}
              subheader={isDesktop ? subtitle : null}
            />
          </Box>
          {children && <Typography variant="body1">{children}</Typography>}
        </Box>

        <Box
          mr={3}
          display="flex"
          alignItems={"center"}
          color={theme.palette.grey[600]}>
          <ChevronRight />
        </Box>
      </Box>
    </Card>
  );
};
